import { GridCellProps } from '@progress/kendo-react-grid';
import { format } from 'date-fns';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import GridCellBase from 'src/components/GridCellBase';
import { GridColumn } from 'src/components/GridWrapper';
import useWindowSize from 'src/hooks/useWindowSize';

const DateSentCell = (props: GridCellProps) => {
  const rawDate = props.dataItem.dateSentRaw;
  const dateTime = new Date(rawDate);
  const formattedDate = format(dateTime, 'MM/dd/yyyy hh:mm a');
  return (
    <GridCellBase {...props} title={formattedDate}>
      <span>{formattedDate}</span>
    </GridCellBase>
  );
};

const useTimingLogColumns = () => {
  const { t } = useTranslation();
  const { width } = useWindowSize();

  const gridWidth = useMemo(() => Math.max(width, 1200), [width]);

  const setPercentage = useMemo(
    () => (percentage: number) => Math.round((gridWidth / 100) * percentage),
    [gridWidth]
  );

  const columns: GridColumn<any>[] = useMemo(
    () => [
      {
        field: 'selected',
        title: '',
        filter: 'boolean',
        menu: false,
        sortable: false,
        width: setPercentage(4),
      },
      {
        field: 'poNum',
        title: t('PO #'),
        filter: 'text',
        sortable: true,
        menu: true,
        width: setPercentage(10),
        show: true,
      },
      {
        field: 'dateSent',
        title: t('Date Sent'),
        filter: 'date',
        dataType: 'date',
        sortable: true,
        menu: true,
        width: setPercentage(10),
        show: true,
        component: DateSentCell,
      },
      {
        field: 'buyer',
        title: t('Buyer'),
        filter: 'text',
        sortable: true,
        menu: true,
        width: setPercentage(10),
        show: true,
      },
      {
        field: 'supplier',
        title: t('Supplier'),
        filter: 'text',
        sortable: true,
        menu: true,
        width: setPercentage(10),
        show: true,
      },
      {
        field: 'distributor',
        title: t('Distributor'),
        filter: 'text',
        sortable: true,
        menu: true,
        width: setPercentage(10),
        show: true,
      },
      {
        field: 'customerNumber',
        title: t('Customer #'),
        filter: 'text',
        sortable: true,
        menu: true,
        width: setPercentage(10),
        show: true,
      },
      {
        field: 'fileName',
        title: t('File Name'),
        filter: 'text',
        sortable: true,
        menu: true,
        width: setPercentage(14),
        show: true,
      },
      {
        field: 'documentId',
        title: t('Document ID'),
        filter: 'text',
        sortable: true,
        menu: true,
        width: setPercentage(12),
        show: true,
      },
    ],
    [setPercentage, t]
  );

  return columns;
};

export default useTimingLogColumns;
